export default __webpack_public_path__ + "static/media/instagram.5b3a03f8.svg";